import React, { useEffect, useState } from "react";
import { FolderOpenTwoTone, InfoCircleTwoTone } from "@ant-design/icons";
import { useAppDispatch } from "../../redux/hooks.ts";
import { setGroupType } from "../../redux/slices/requirementsSlice.ts";

const viewOptions = [
  { label: "Por estatus", value: "status", icon: <InfoCircleTwoTone /> },
  { label: "Por subcarpeta", value: "subfolder", icon: <FolderOpenTwoTone /> },
];

export const SwitchRequirementsView: React.FC = () => {
  const [selected, setSelected] = useState<string>(viewOptions[0].label);
  const dispatch = useAppDispatch();

  const handleToggle = (option: "status" | "subfolder") => {
    setSelected(option);
    dispatch(setGroupType(option));
  };

  useEffect(() => {
    handleToggle("status");
  }, []);

  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="flex space-x-4">
        {viewOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => handleToggle(option.value as any)}
            className={`flex items-center justify-center px-4 py-3 border rounded-lg focus:outline-none ${
              selected === option.value
                ? "border-blue-600 bg-blue-50 text-blue-600"
                : "border-gray-300 text-gray-700"
            }`}
          >
            <span
              className={`w-4 h-4 mr-2 rounded-full border-2 flex items-center justify-center ${
                selected === option.value
                  ? "border-blue-600"
                  : "border-gray-300"
              }`}
            >
              {selected === option.value && (
                <span className="w-2 h-2 bg-blue-600 rounded-full" />
              )}
            </span>

            <span className="mr-2 text-lg">{option.icon}</span>
            <span className="font-medium">{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
